import { workflowStage } from "./components/EvidenceDetails/Workflow/start";
import { dataStreamTypes, nodeTypes, quantEvidence, scoreTypes, txtminingFields } from "./types";

export const normalizeDate = (d) => {
  const normalizedDate = new Date(d);
  normalizedDate.setHours(0, 0, 0, 0);
  return normalizedDate;
};

export function toPercentage(x: number) {
  return Math.round(x * 100) + '%';
}

export const roundToDecimals = (num, decimals) => {
  const factor = Math.pow(10, decimals);
  return Math.round(num * factor) / factor;
};

export function formatNumber(value: number): string {
  let formatted = value.toFixed(2);
  
  if (parseFloat(formatted) === Math.floor(value)) {
    formatted = Math.floor(value).toString();
  }

  return formatted;
}

export const mscore = (scores, weights, streamsEnabled) => {
  if (scores === null) return null

  return Object.keys(streamsEnabled).filter(k => streamsEnabled[k]).reduce((sum, key) => {
    const value = scores[key];
    const weight = weights[key];
    return sum + value * weight;
  }, 0);
}

export const saturation = (a, x) => {
  return (2 / (1 + Math.exp(-a * x))) - 1
}

export const WeightedScores = (scores, weights, streamsEnabled) => {
  if (scores === null) return null

  return Object.keys(streamsEnabled).filter(k => streamsEnabled[k]).reduce((details, key) => {
    const value = scores[key as keyof typeof scores];
    const weight = weights[key as keyof typeof weights];
    details[key] = value * weight
    return details;
  }, {});
}

export function getHardcodedColor(domain: string) {
  switch (domain) {
    case nodeTypes.anatomy:
      return "#E477B1";
    case nodeTypes.component:
      return "#ccebc5";
    case nodeTypes.disease:
      return "#C19A6B";
    case nodeTypes.drug:
      return "#8dd3c7";
    case nodeTypes.exposure:
      return "#fccde5";
    case nodeTypes.function:
      return "#D3D397";
    case nodeTypes.gene:
      return "#bc80bd";
    case nodeTypes.pathway:
      return "#bebada";
    case nodeTypes.phynotype:
      return "#fb8072";
    case nodeTypes.process:
      return "#b3de69";
    case nodeTypes.moa:
      return "#1f78b4";
    case scoreTypes.mscore:
      return "#ADACAC"
    case dataStreamTypes.diffexpr:
      return "#f58a68"
    case dataStreamTypes.miningNovelty:
      return "#00e47c"
    case dataStreamTypes.miningOverall:
      return "#08312a"
    case dataStreamTypes.otp:
      return "#928bde"
    case dataStreamTypes.otg:
      return "#076D7E"
    case txtminingFields.mutation:
      return '#fbb4ae'
    case txtminingFields.relation:
      return '#ccebc5'
    case txtminingFields.hit:
      return '#b3cde3'
    default:
      return "blue"
  }
}

export function getHardcodedLabels(domain: string) {
  switch (domain) {
    case scoreTypes.mscore:
      return "M_Score"
    case scoreTypes.detailedScore:
      return "Detailed Score"
    case dataStreamTypes.diffexpr:
      return "Differential Expression"
    case dataStreamTypes.miningNovelty:
      return "Text Mining Novelty"
    case dataStreamTypes.miningOverall:
      return "Text Mining Overall"
    case dataStreamTypes.otp:
      return "Genetic Associations"
    case dataStreamTypes.otg:
      return "Biobank Proteomics"
    case txtminingFields.hit:
      return "Hit"
    case txtminingFields.mutation:
      return "Mutation"
    case txtminingFields.relation:
      return "Relation"
    case nodeTypes.disease:
      return "Indication"
    case nodeTypes.gene:
      return "Gene"
    case workflowStage.geneContribution:
      return "Gene Contribution Analysis"
    case workflowStage.saturation:
      return "Evidence Saturation"
    case workflowStage.weightedScores:
      return "Weighted Score Calculation"
    case workflowStage.weightedSum:
      return "Final Score Aggregation"
    default:
      return "Not recognized"
  }
}

export function QuantEvidence2DataStream(quantEnv: string) {
  switch (quantEnv) {
    case quantEvidence.total_comentions:
      return dataStreamTypes.miningOverall
    case quantEvidence.odds_ratio:
      return dataStreamTypes.miningNovelty
    case quantEvidence.diffexpr_up:
      return dataStreamTypes.diffexpr
    case quantEvidence.diffexpr_down:
      return dataStreamTypes.diffexpr
    case quantEvidence.bbprot_up:
      return dataStreamTypes.otg
    case quantEvidence.bbprot_down:
      return dataStreamTypes.otg
    case quantEvidence.methods_count:
      return dataStreamTypes.otp
  }
}

export function DataStream2QuantEvidence(dstream: string) {
  switch (dstream) {
    case dataStreamTypes.miningOverall:
      return quantEvidence.total_comentions
    case dataStreamTypes.miningNovelty:
      return quantEvidence.odds_ratio
    case dataStreamTypes.otp:
      return quantEvidence.methods_count
  }
}